app.service('operatorMaxInstalment',function( ) {
	var $expectedRate, $remainingWorthOnline, $remainingWorthOffline;
	var instalmentDuration=0;

	function prepare(duration) {
		if(duration){
			instalmentDuration=duration;
		}
		if($expectedRate.val()==''){
			clearRemainingWorth();
			return;
		}
	}

	function getData(){
		return $expectedRate.val() || 0;
	}
	function clear(){
		$expectedRate.val('');
		clearRemainingWorth();
	}
	function clearRemainingWorth(){
		$remainingWorthOnline.val('');
		$remainingWorthOffline.val('');
	}
	function setEvents(){
		clearRemainingWorth();
		$expectedRate.val('').on('keyup', function() {
			prepare();
		});
		$(document).on('cartReady',function(event,data){
			clearRemainingWorth();
			prepare();
		});
	}
	function setElements() {
		$expectedRate = $('#expected-rate');
		$remainingWorthOnline = $('#remaining-worth-online');
		$remainingWorthOffline = $('#remaining-worth-offline');
	}
	function init(){
		setElements();
		setEvents();
	}
	return {
		init, getData, clear, prepare
	};
});
